import { render, staticRenderFns } from "./ExclusiveHomePhone.vue?vue&type=template&id=0560b7a1&"
import script from "./ExclusiveHomePhone.vue?vue&type=script&lang=js&"
export * from "./ExclusiveHomePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports